import { NavLink } from 'react-router-dom';

interface MobileNavProps {
  username?: string;
}

export function MobileNav({ username }: MobileNavProps) {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden flex justify-around p-2"
      style={{
        background: 'var(--bg-card)',
        borderTop: '1px solid var(--border-card)',
      }}
    >
      <NavLink to="/" end className="text-xl no-underline">📰</NavLink>
      <NavLink to="/discover" className="text-xl no-underline">🔭</NavLink>
      <NavLink to={username ? `/@${username}` : '/login'} className="text-xl no-underline">👤</NavLink>
      <NavLink to="/groups" className="text-xl no-underline">👥</NavLink>
      <NavLink to="/upgrade" className="text-xl no-underline">⚡</NavLink>
    </nav>
  );
}
